export default __webpack_public_path__ + "static/media/progress.67ed1738.svg";